import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container } from "../components/basic.js";
import { Link } from "../components/text.js";
import { Text } from "../components/text.js";
import { ThirdwebTextIcon } from "./icons/ThirdwebTextIcon.js";
/**
 * @internal
 */
export function PoweredByThirdweb() {
    return (_jsx(Link, { color: "secondaryText", hoverColor: "primaryText", target: "_blank", href: "https://thirdweb.com/connect?utm_source=cw_text", children: _jsxs(Container, { flex: "row", center: "both", style: {
                color: "currentColor",
                gap: 4,
            }, children: [_jsx(Text, { size: "sm", weight: 600, style: {
                        color: "currentColor",
                    }, children: "Powered by" }), _jsx(ThirdwebTextIcon, { height: 13 })] }) }));
}
//# sourceMappingURL=PoweredByTW.js.map